module.exports = __webpack_public_path__ + "fonts/fa-solid-900---f6121be597a72928f54e7ab5b95512a1.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/@fortawesome/fontawesome-free/webfonts/fa-solid-900.woff2
// module id = 381
// module chunks = 0